var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
export const UserProfileSubtitle = (_a) => {
    var { actions } = _a, rest = __rest(_a, ["actions"]);
    const classes = useStyles(rest);
    const translate = useTranslate();
    return (React.createElement(Typography, { className: classes.root, variant: "subtitle1" }, translate('resources.userContexts.fields.userDetails.password')));
};
const useStyles = makeStyles(theme => ({
    root: {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(2),
        color: theme.palette.getContrastText(theme.palette.background.default),
    },
}), {
    name: 'Layer7UserContextSubtitle',
});
//# sourceMappingURL=UserProfileSubtitle.js.map